<template>
  <v-container v-if="loading" fluid fill-height>
    <v-layout align-center justify-center fill-height>
      <v-progress-circular indeterminate></v-progress-circular>
    </v-layout>
  </v-container>
  <v-container v-else>
    <v-layout>
      <v-speed-dial v-model="fab" direction="right" left transition="slide-x-transition">
        <template v-slot:activator>
          <v-btn fab v-model="fab" v-on="on">
            <v-icon>add</v-icon>
            <v-icon>close</v-icon>
          </v-btn>
          <!--</template>
            <span>{{$t(category.id)}}</span>
          </v-tooltip>-->
        </template>

        <!--<v-tooltip bottom v-for="category in categories" :key="category.id">
          <template v-slot:activator="{ on }">-->
            <v-btn fab @click="addFeature(category)" v-on="on" v-for="category in categories" :key="category.id">
              <v-icon :color="category.color">{{category.icon}}</v-icon>
            </v-btn>
          <!--</template>
          <span>{{$t(category.id)}}</span>
        </v-tooltip>-->
      </v-speed-dial>
    </v-layout>
    <v-card>
      <!--<v-toolbar dark>
        <v-toolbar-title>{{$t('menu.features')}}</v-toolbar-title>
        <v-spacer />
        <v-menu bottom left min-width="250">
          <template v-slot:activator="{ on }">
            <v-btn icon v-on="on">
              <v-icon>add</v-icon>
            </v-btn>
          </template>
          <v-list>
            <v-list-tile
              v-for="category in categories"
              :key="category.id"
              @click="addFeature(category.id)"
            >
              <v-list-tile-avatar>
                <v-icon>{{category.icon}}</v-icon>
              </v-list-tile-avatar>
              <v-list-tile-title>{{$t(category.id)}}</v-list-tile-title>
            </v-list-tile>
          </v-list>
        </v-menu>
      </v-toolbar>-->
      <v-list subheader>
        <span v-for="(items, category) in localFeatures" :key="category">
          <v-divider />

          <v-subheader>{{$t(category)}}</v-subheader>
          <v-list-tile style="width: 100%" v-for="(item, idx) in items" :key="idx" avatar>
            <v-list-tile-avatar>
              <v-menu bottom left>
                <template v-slot:activator="{ on }">
                  <v-btn icon v-on="on">
                    <v-icon :color="item.color">{{item.icon}}</v-icon>
                  </v-btn>
                </template>
                <v-card>
                  <v-container grid-list-xs>
                    <v-layout rpw wrap>
                      <v-flex xs3 v-for="icon in icons" :key="icon">
                        <v-btn icon @click="item.icon = icon">
                          <v-icon>{{icon}}</v-icon>
                        </v-btn>
                      </v-flex>
                    </v-layout>
                  </v-container>
                </v-card>
              </v-menu>
            </v-list-tile-avatar>
            <v-layout row wrap>
              <v-flex xs9>
                <v-text-field v-model="item.title" autofocus></v-text-field>
              </v-flex>
              <v-flex xs3>
                <v-text-field v-model.trim="item.address"></v-text-field>
              </v-flex>
            </v-layout>
            <v-list-tile-action>
              <v-menu bottom left>
                <template v-slot:activator="{ on }">
                  <v-list-tile-avatar>
                    <v-btn icon v-on="on">
                      <v-icon :color="item.color">color_lens</v-icon>
                    </v-btn>
                  </v-list-tile-avatar>
                </template>
                <swatches-picker :value="item.color" @input="updateColor($event, item)"></swatches-picker>
              </v-menu>
            </v-list-tile-action>
            <v-list-tile-action>
              <v-menu bottom left :close-on-content-click="false" min-width="250">
                <template v-slot:activator="{ on }">
                  <v-btn icon v-on="on">
                    <v-icon>settings</v-icon>
                  </v-btn>
                </template>
                <v-card>
                  <v-list>
                    <v-list-tile>
                      <v-list-tile-avatar>
                        <v-icon>settings</v-icon>
                      </v-list-tile-avatar>
                      <v-list-tile-title>Settings</v-list-tile-title>
                    </v-list-tile>
                  </v-list>
                  <v-divider></v-divider>
                  <v-list>
                    <v-list-tile @click="removeFature(category, idx)">
                      <v-list-tile-action>
                        <v-icon>delete</v-icon>
                      </v-list-tile-action>
                      <v-list-tile-title>Delete</v-list-tile-title>
                    </v-list-tile>
                    <!--@click="toggleOnlyAudio(category, idx)"-->
                    <v-list-tile v-if="category=='cameras'">
                      <v-list-tile-action>
                        <v-switch v-model="item.audio" color="purple"></v-switch>
                      </v-list-tile-action>

                      <v-list-tile-title>{{item.audio ? 'Only audio device (no video)' : 'Audio / video device'}}</v-list-tile-title>
                      <v-list-tile-avatar>
                        <v-icon v-if="item.audio">videocam_off</v-icon>
                        <v-icon v-else>videocam</v-icon>
                      </v-list-tile-avatar>
                    </v-list-tile>
                  </v-list>
                </v-card>
              </v-menu>

              <!--<v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <v-btn icon v-on="on" @click="removeFature(category, idx)">
                    <v-icon>remove</v-icon>
                  </v-btn>
                </template>
                <span>Remove</span>
              </v-tooltip>-->
            </v-list-tile-action>
          </v-list-tile>
        </span>
      </v-list>

      <transition name="fade">
        <v-alert :value="error" type="error">{{error}}</v-alert>
      </transition>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="blue darken-1" flat @click.native="dialog = false">Close</v-btn>
        <v-btn color="blue darken-1" flat @click.native="save">Save</v-btn>
      </v-card-actions>
    </v-card>
  </v-container>
</template>


<script>
import { mapState } from "vuex";
import router from "@/router";
import { constants } from "fs";
import { /*Photoshop,*/ Swatches } from "vue-color";

export default {
  name: "duo-features",
  components: {
    //"photoshop-picker": Photoshop,
    "swatches-picker": Swatches
  },

  mounted() {
    this.$store.dispatch("duo/features").then(() => {
      this.loadFeatures();
    });
  },
  data: () => {
    return {
      fab: false,
      colors: "#FF0000",
      icons: [
        "vpn_key",
        "cloud",
        "camera_alt",
        "whatshot",
        "opacity",
        "touch_app",
        "visibility"
      ],
      categories: [
        {
          id: "cameras",
          icon: "photo_camera",
          color: "#0097A7",
          default_name: "default.categories.camera"
        },
        {
          id: "actuators",
          icon: "vpn_key",
          color: "#388E3C",
          default_name: "default.categories.actuator"
        },
        {
          id: "sensors",
          icon: "hearing",
          color: "#81C784",
          default_name: "default.categories.sensor"
        }
      ],
      dialog: false,
      editing: false,
      error: null,
      localFeatures: {}
    };
  },
  computed: {
    ...mapState("duo", ["loading", "features"])
  },
  methods: {
    toggleOnlyAudio(category, idx) {
      console.log(this.localFeatures[category][idx]);
      if ("video" in this.localFeatures[category][idx]) {
        this.$delete(this.localFeatures[category][idx], "video");
      } else {
        this.$set(this.localFeatures[category][idx], "video", "off");
      }
    },
    removeFature(category, idx) {
      console.log(category);
      console.log(idx);
      console.log(this.localFeatures[category][idx]);
      var removed = this.localFeatures[category].splice(idx, 1);
      console.log(removed);
    },
    updateColor(value, item) {
      console.log(value, item);
      item.color = value.hex;
    },
    loadFeatures: function() {
      console.log("Loading features: ", this.features);
      this.localFeatures = JSON.parse(JSON.stringify(this.features));
    },
    addFeature(category) {
      if (!this.localFeatures[category.id])
        this.localFeatures[category.id] = [];
      let defaultAddress = String(
        Math.max(
          ...this.localFeatures[category.id].map(item => item.address),
          0
        ) + 1
      );
      this.localFeatures[category.id].push({
        address: defaultAddress,
        icon: category.icon,
        color: category.color,
        title: this.$t(category.default_name)
      });
      console.log(this.localFeatures);
    },
    save: function() {
      this.$store
        .dispatch("duo/saveFeatures", this.localFeatures)
        .then(() => {
          this.dialog = false;
        })
        .catch(e => {
          //segnalare l'errore
          console.log(e.response);
          this.error = e.response.data.message || e;
        });
    }
  }
};
</script>

<style>
</style>
